import { CircularProgress, Link } from '@healthinal/ui';
import { FileDetailsDto } from '../../api/generated/model';
import { useOpenFile } from '../../hooks/useOpenFile.ts';

export function FileLink({ flex, fileDetails }: { flex?: number; fileDetails: FileDetailsDto }) {
  const { isFileLoading, openFile } = useOpenFile();
  return (
    <Link
      disabled={isFileLoading}
      flex={flex}
      level={'title-sm'}
      underline={'none'}
      endDecorator={isFileLoading && <CircularProgress />}
      onClick={() => openFile(fileDetails)}>
      {fileDetails.fileName}
    </Link>
  );
}
